<template>
  <div :class="['step-bar', row ? 'row' : '']">
    <div class="step-item" v-for="(item, i) in list" :key="i">
      <div :class="['item-wrap', step > i ? 'ed' : step == i ? 'ing' : 'un']">
        <div class="ico" v-if="!row">
          <div></div>
          <van-icon v-if="step == i" name="checked" />
          <van-icon v-else name="passed" />
          <div></div>
        </div>
        <div class="ico" v-else>
          <div></div>
          <i></i>
          <div></div>
        </div>

        <div class="txt">
          <div>{{ item.content }}</div>
          <p>{{ item.time }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    step: {
      type: Number,
      default: 0
    },
    row: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.step-bar {
  position: relative;
  min-height: 78px;
  display: flex;
  overflow-x: scroll;
  &.row {
    flex-direction: column;
    overflow: unset;
    .step-item {
      min-width: unset;
      height: 75px;
      padding-left: 45px;
      &:first-child {
        margin-top: -17.5px;
      }
      .item-wrap {
        display: flex;
        height: 100%;
        .ico {
          display: flex;
          flex-direction: column;
          height: 100%;
          i {
            display: block;
            height: 8px;
            width: 8px;
            background-color: #6cdd8f;
            border-radius: 4px;
          }
          div {
            flex: 1;
            width: 2px;

            background-color: #16d77a;
          }
        }
        .txt {
          display: flex;
          flex-direction: column;
          justify-content: center;
          text-align: left;
          margin-left: 15px;
        }
      }
    }
  }
  .step-item {
    min-width: 130px;
    &:first-child {
      .ico {
        div:first-child {
          background-color: unset;
        }
      }
    }

    &:last-child {
      .ico {
        div:last-child {
          background-color: unset;
        }
      }
    }
    .item-wrap {
      .ico {
        display: flex;
        align-items: center;
        i {
          font-size: 30px;
          color: #16d77a;
        }
        div {
          flex: 1;
          height: 2px;
          background-color: #16d77a;
        }
      }
      .txt {
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        div {
          color: #16d77a;
          margin-top: 10px;
          width: 100%;
          max-width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          display: -moz-box;
          -moz-line-clamp: 2;
          -moz-box-orient: vertical;
          word-wrap: break-word;
          word-break: break-all;
          white-space: normal;
        }
        p {
          color: #999;
        }
      }
      &.ed {
        .ico {
          i {
          }
          div {
          }
        }
      }
      &.ing {
        .ico {
          i {
          }
          div {
          }
        }
      }
      &.un {
        .ico {
          i {
            color: #999999;
          }
          div {
          }
        }
        .txt {
          display: none;
        }
      }
    }
  }
}
</style>
